import { useEffect, useState } from "react";
import { AirdropSelectAmountPageTemplateProps} from "./template";
import { useLocation, useNavigate } from "react-router";
import { PagePaths, AirdropPagePaths } from "../../../../types";

export const useAirdropSelectAmountPage = (): AirdropSelectAmountPageTemplateProps => {
    const location = useLocation();
    const navigate = useNavigate();
    const combinedData = location.state?.combinedData;
    const offerSelected = combinedData?.offerSelected;
    const selectedUser = combinedData?.selectedUser;
    const [progress, setProgress] = useState(50);

    const navigateTo = (to: string, data: any, message: string) => {
        const assembledData = {amount: data, message, combinedData };
        navigate(to, {state: {assembledData}})
    }

    useEffect(() => {
        if (!offerSelected || !selectedUser) {
            navigate(`/dashboard/${PagePaths.airdrop}/${AirdropPagePaths.selectMembers}`);
        }
    }, [offerSelected, selectedUser, navigate]);


    useEffect(() => {
        console.log(JSON.stringify(offerSelected))
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => setProgress(75), 1000);
        return () => clearTimeout(timer);
      }, []);

    const onReturnPressed = () => {
        console.log("onReturnPressed");
        navigate(-1);
    }

    const onContinuePressed = (data: any, message: string) => {
        const to = "/dashboard/airdrop/confirm";
        navigateTo(to, data, message); 
    }

    return {
        offerSelected,
        progress,
        onReturnPressed,
        onContinuePressed,
        selectedUser,
    }
}
